import React, {useState, useEffect, useContext} from 'react'
import {Link} from "react-router-dom";
import {useAlert} from "react-alert";
import authContext from "../../context/auth/authContext";
import Swal from 'sweetalert2'


const Register = () => {
    const AuthContext = useContext(authContext);
    const alert = useAlert()
    const {auth, register, clearAlert} = AuthContext;
    let [disable_button, setDisable_button] = useState(false);
    let [hide_spinner, setHide_spinner] = useState("d-none");

    useEffect(() => {
        if (auth.message.msg !== "") {
            alert.show(
                auth.message.msg, auth.message.msg_options
            )
            clearAlert()
            setDisable_button(false)
            setHide_spinner("d-none")
        }
    }, [auth.message.msg])

    const submitHandler = async (e) => {
        e.preventDefault()
        setDisable_button(true);
        setHide_spinner("d-inline-block");

        let registration_form = document.getElementById("registration_form");
        let user_data = new FormData(registration_form);
        let res = await register(user_data);
        console.log(res.request.status)
        if (res.request.status === 201){
            Swal.fire({
                icon: 'success',
                title: 'Congratulations 😊',
                text: 'Your account is almost ready. Open your email inbox and click on the activation link sent to you.',
                footer: '<a href="/">Go to homepage</a>'
            })
        }

    }

    return (
        <div className="login-sect">
            <div className="split-grid-sect">
                <div className="split-grid-2 h-100 bg-white">
                    <div className="login-details-show d-flex justify-content-center align-items-center h-100">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 mx-auto">
                                    <h2 className="make-bold">Sign up</h2>
                                    <p>Create an account</p>
                                    <form onSubmit={submitHandler}
                                          id="registration_form"
                                          encType="multipart/form-data">
                                        <div className="form-group">
                                            <label>First Name</label>
                                            <input type="text" className="form-control"
                                                   placeholder="First name"
                                                   name="first_name"
                                                   required="required"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Last Name</label>
                                            <input type="text" className="form-control"
                                                   placeholder="Last name"
                                                   name="last_name"
                                                   required="required"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Email Address</label>
                                            <input type="email" className="form-control"
                                                   placeholder="Last name"
                                                   name="email"
                                                   required="required"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Password</label>
                                            <input type="password" className="form-control"
                                                   placeholder="Password"
                                                   name="password"
                                                   required="required"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Confirm Password</label>
                                            <input type="password" className="form-control"
                                                   placeholder="Confirm Password"
                                                   name="confirm_password"
                                                   required="required"
                                            />
                                        </div>

                                        <div className="form-group form-check">
                                            <input type="checkbox" className="form-check-input" id="loginCheck1"
                                                   required/>
                                            <label className="form-check-label" htmlFor="loginCheck1">I agree to
                                                AppName's <a
                                                    href="">Terms and Conditions</a> and <a href="">Privacy
                                                    Policy</a>.</label>
                                        </div>
                                        <div className="form-group">
                                            <button type="submit"
                                                    className="btn btn-gravity-secondary text-white make-medium btn-block"
                                                    disabled={disable_button}>

                                                Create an account
                                                <span
                                                    className={"spinner-border spinner-border-sm ml-2 " + hide_spinner}
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </button>
                                        </div>
                                    </form>

                                    <div className="text-center">
                                        <Link to="/login" className="text-gravity-secondary">
                                            <span className="make-medium">I have an account? Login</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="split-grid-1 bg-primary add-bg-image position-relative d-none d-xl-block d-lg-block">
                    <div id="carouselAdminIndicators" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="add-overlay"></div>
                                <div className="img-holder-10">
                                    <img src="images/banner-3.jpg" className="d-block w-100 ob-fit vh-100-2" alt="..."/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default Register